import { createSlice } from "@reduxjs/toolkit";

const tokenSlice = createSlice({
  name: "tokenSlice",
  initialState: {
    token: localStorage.getItem("token") || null,
  },
  reducers: {
    setToken(state, { payload }) {
      state.token = payload;
      if (!state.token) {
        localStorage.removeItem("token");
      } else {
        localStorage.setItem("token", payload);
      }
    },
  },
});

export default tokenSlice.reducer;

export const {
  setToken,
} = tokenSlice.actions;